import { useTranslation } from "react-i18next";
import { Button } from "@guardian/shared-ui";

interface ErrorFallbackProps {
  message?: string;
}

export function ErrorFallback({ message }: ErrorFallbackProps) {
  const { t } = useTranslation();
  return (
    <div role="alert" className="flex flex-col items-center justify-center p-8 text-center">
      <p className="text-lg font-medium text-destructive">
        {message || t('errors.somethingWentWrong')}
      </p>
      <p className="mt-2 text-sm text-muted-foreground">
        {t('errors.tryRefreshing')}
      </p>
      <Button
        onClick={() => window.location.reload()}
        className="mt-4"
      >
        {t('actions.refresh', 'Refresh page')}
      </Button>
    </div>
  );
}
